<div class="gap-10">
  <h2>{{ data.header }}</h2>
  <p>{{ data.body }}</p>
</div>
<div class="flex gap-16">
  <app-button (click)="close($event)">
    {{ data.buttonText || 'OK' }}
  </app-button>
</div>

